/**
 * App Layout Component
 *
 * Main application shell with sidebar navigation and header.
 * Renders child routes via Outlet.
 */

import { AIChatProvider, useAIChat } from '@/features/ai-chat';
import { AIChatDrawer } from '@/features/ai-chat/components';
import { ReimbursementLinkProvider } from '@/features/transactions/components/reimbursement-link/reimbursement-link-context';
import { cn } from '@/shared/utils';
import { useEffect, useState } from 'react';
import { AnimatedOutlet } from './animated-outlet';
import { Sidebar } from './sidebar';
import { ThemeSync } from './theme-sync';

function AppLayoutInner() {
  const { isOpen } = useAIChat();
  const [isElectron, setIsElectron] = useState(false);
  useEffect(() => {
    setIsElectron(navigator.userAgent.toLowerCase().includes('electron'));
  }, []);

  return (
    <div className='flex flex-col h-screen bg-background'>
      {isElectron && <div className='drag-region h-10 shrink-0 bg-card border-b border-border/50' />}
      <div className='flex flex-1 overflow-hidden relative gap-2'>
        <Sidebar />
        <main
          className={cn(
            'flex-1 overflow-auto p-6 bg-card rounded-2xl shadow-xl relative z-10 my-3 transition-all duration-300',
            isOpen ? 'mr-0' : 'mr-3',
          )}
        >
          <AnimatedOutlet />
        </main>
        {isOpen && <AIChatDrawer />}
      </div>
    </div>
  );
}

export function AppLayout() {
  return (
    <ReimbursementLinkProvider>
      <AIChatProvider>
        <ThemeSync />
        <AppLayoutInner />
      </AIChatProvider>
    </ReimbursementLinkProvider>
  );
}
